import { useRef } from "react";
import styles from "./InstructorSelector.module.css";
import avatarImage from '../../assets/icons/avatar.png';

const InstructorSelector = ({ instructors, selectedId, onSelect }) => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Filter by Instructor</h2>

      <div className={styles.scrollContainer}>
        <button className={styles.arrow} onClick={scrollLeft}>
          ❮
        </button>

        <div className={styles.instructorList} ref={scrollRef}>
          {instructors.map((inst) => (
            <div
              key={inst.id}
              className={`${styles.instructorCard} ${selectedId === inst.id ? styles.active : ""}`}
              onClick={() => onSelect(inst.id)}
            >
              <div className={styles.avatarWrapper}>
                <img
                  src={inst.avatar || avatarImage}
                  alt={inst.name}
                  className={styles.avatar}
                />
              </div>
              <p className={styles.name}>{inst.name}</p>
            </div>
          ))}
        </div>
        <button className={styles.arrow} onClick={scrollRight}>
          ❯
        </button>
      </div>
    </div>
  );
};

export default InstructorSelector;
